export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11862.35000e4d.jpg";